<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">Change PIN Number</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content" *ngIf="step === 1">
        <p>Enter your current PIN to verify and proceed:</p>

        <form [formGroup]="currentPinForm">
          <label class="outlined-input" [class.input-error]="showCurrentError">
            <input [type]="showCurrentPin ? 'text' : 'password'" formControlName="pin"
              (input)="showCurrentError = false" maxlength="4" placeholder=" " restrictNumbers appPreventPaste>
            <span>Current PIN Number <span class="star hide">*</span></span>

            <img class="eye" [src]="showCurrentPin ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="showCurrentPin = !showCurrentPin" *ngIf="currentPinForm.controls.pin.value" alt="eye icon"
              height="16" width="16">
          </label>

          <p *ngIf="currentPinForm.controls.pin.touched && currentPinForm.controls.pin.hasError('required')"
            class="validation-message">
            Current PIN is required
          </p>

          <p *ngIf="showCurrentError && !currentPinForm.controls.pin.hasError('required')" class="validation-message">
            Invalid PIN number. Try again!
          </p>
        </form>
      </div>

      <div class="modal-content" *ngIf="step === 2">
        <p>Enter your new PIN Number:</p>

        <form [formGroup]="newPinForm">
          <label class="outlined-input"
            [class.input-error]="newPinForm.controls.confirmNewPin.value && newPinForm.hasError('mismatch') || !validatePin()">
            <input [type]="showNewPin ? 'text' : 'password'" formControlName="newPin"
              (input)="showCurrentError = false" maxlength="4" placeholder=" " restrictNumbers appPreventPaste>

            <span>Enter New PIN <span class="star hide">*</span></span>

            <img class="eye" [src]="showNewPin ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="showNewPin = !showNewPin" *ngIf="newPinForm.controls.newPin.value" alt="eye icon" height="16"
              width="16">
          </label>

          <p *ngIf="newPinForm.controls.newPin.touched && newPinForm.controls.newPin.hasError('required')"
            class="validation-message">
            New PIN is required
          </p>

          <p *ngIf="newPinForm.controls.newPin.touched && newPinForm.controls.newPin.hasError('minlength')"
            class="validation-message">
            Invalid PIN number. Try again!
          </p>

          <div class="info-banner" *ngIf="!validatePin()">
            <div class="banner-box">
              <img alt="info" src="assets/icon/twisted-primary-info.svg" height="16" width="16">
              <div class="banner-note">
                <p class="caption">PIN code shouldn’t be:</p>
                <ul>
                  <li><p class="caption">A sequential number: i.e.: 1234 or 9876</p></li>
                  <li class="last"><p class="caption">A sequence of the same number i.e 1111, 2222, etc</p></li>
                </ul>
              </div>
            </div>
          </div>


          <label class="outlined-input"
            [class.input-error]="newPinForm.controls.confirmNewPin.value && newPinForm.hasError('mismatch')">
            <input [type]="showConfirmPin ? 'te' : 'password'" formControlName="confirmNewPin"
              (input)="showCurrentError = false" maxlength="4" placeholder=" " restrictNumbers appPreventPaste>

            <span>Confirm New PIN <span class="star hide">*</span></span>

            <img class="eye" [src]="showConfirmPin ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="showConfirmPin = !showConfirmPin" *ngIf="newPinForm.controls.confirmNewPin.value" alt="eye icon"
              height="16" width="16">
          </label>

          <p *ngIf="newPinForm.controls.confirmNewPin.touched && newPinForm.controls.confirmNewPin.hasError('required')"
            class="validation-message">
            Confirm PIN is required
          </p>

          <p *ngIf="newPinForm.controls.confirmNewPin.value && newPinForm.hasError('mismatch')"
            class="validation-message">
            PIN Codes don't match. Try again
          </p>
        </form>
      </div>

      <div class="modal-actions">
        <button *ngIf="step === 1" class="button primary" (click)="submitCurrentPin()">Submit</button>
        <button *ngIf="step === 2" class="button primary" (click)="editAccountPin()">Save</button>
        <button class="button tertiary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
